import { render, staticRenderFns } from "./OgHomeHero.vue?vue&type=template&id=2434964f&scoped=true"
import script from "./OgHomeHero.vue?vue&type=script&lang=js"
export * from "./OgHomeHero.vue?vue&type=script&lang=js"
import style0 from "./OgHomeHero.vue?vue&type=style&index=0&id=2434964f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2434964f",
  null
  
)

export default component.exports